import { render, staticRenderFns } from "./UploadStudentSkillForm.vue?vue&type=template&id=4709b428&"
import script from "./UploadStudentSkillForm.vue?vue&type=script&lang=js&"
export * from "./UploadStudentSkillForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports